export default __webpack_public_path__ + "static/media/Ellipse 1.7f2a53ae.png";